module.exports = __webpack_public_path__ + "img/logoblk.49709699.png";